import React, { Component } from "react";

import { Link } from 'react-router-dom';
import TextField from '@material-ui/core/TextField';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Button from '@material-ui/core/Button';

class TmxSelectionForm extends Component {
	constructor(props) {
		super(props);
		this.handleChange=this.handleChange.bind(this);
		this.handleSubmit=this.handleSubmit.bind(this);
		
		this.state={ 
			selection:this.props.selectedId
		}
	}
	
	handleChange(e){
		e.preventDefault();
		this.setState({selection: parseInt(e.target.value) });
	}
	
	handleSubmit(e){
		e.preventDefault();
		this.props.changeTmx(this.state.selection);
	}
	
	render() {
		var tmxSel=[];
//		console.log("[TmxSelectionForm.render()]: "+JSON.stringify(this.props.tmxList));
		this.props.tmxList.forEach((tmx) => {
			tmxSel.push(<FormControlLabel value={tmx.id} key={tmx.id} control={<Radio />} label={tmx.description} />);
		});
		return (
			<div class="contentM">
				<h1>TMX for customer {this.props.customer.name}:</h1>
				<RadioGroup aria-label="tmx" name="tmx1" value={this.state.selection} onChange={this.handleChange}>
				{tmxSel}
				</RadioGroup>
				<Button variant="contained" color="primary" aria-label="Close" onClick={this.handleSubmit}>
					Save
				</Button>
			</div>
		);
	}
}

export default TmxSelectionForm;